<template>
  <v-container fluid>
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="backRoute">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true"> New Schedule </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>
    <teacher-schedule-form
      v-if="loaded"
      v-model="schedule"
      :teacher="teacher"
      @clickedSave="saveSchedule"
      :cancelPath="backRoute"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const TeacherScheduleForm = () =>
  import("@/components/teacher/TeacherScheduleForm.vue");
const PageHeader = () => import("@/components/common/PageHeader.vue");
import moment from "moment";

export default {
  components: { TeacherScheduleForm, PageHeader },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "currentUser"]),
  },
  data() {
    return {
      teacher: null,
      backRoute: {
        name: "Teacher",
        params: { id: this.$route.params.teacherId, tab: "tab-info" },
      },
      schedule: null,
      loaded: false,
    };
  },
  async created() {
    this.teacher = await this.initTeacher();

    this.schedule = await this.initSchedule();

    if (this.teacher && this.schedule) {
      this.schedule.teacherId = this.teacher.id;

      if (this.teacher.hourlyRates && this.teacher.hourlyRates.length > 0) {
        const matchRate = this.teacher.hourlyRates.find(
          (e) => e.hourlyRate == this.schedule.hourRate
        );
        if (matchRate) {
          this.schedule.rateId = matchRate.id;
        }
      }
    }

    this.loaded = true;
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    async initTeacher() {
      const teacherId = this.$route.params.teacherId
        ? this.$route.params.teacherId
        : null;
      if (teacherId) {
        return await this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then((resp) => {
            return resp.data.data;
          });
      }
    },
    async initSchedule() {
      const id = this.$route.query.scheduleId;
      const type = this.$route.query.scheduleType;
      const date = null;

      let schedule = null;

      if (id && type) {
        const result = await this.$axios.get("staff/schedule", {
          params: { schedule_id: id, staff_type: type, date },
        });

        schedule = result.data;
        if (schedule.rrule) {
          schedule.startDate = schedule.recurringStartDate;
          schedule.endDate = schedule.recurringEndDate;

          schedule.startTime = moment(schedule.startTime).format("HH:mm");
          schedule.endTime = moment(schedule.endTime).format("HH:mm");
          schedule.daysOfWeek = schedule.daysOfWeek
            ? schedule.daysOfWeek.split(",")
            : [];
        }
        return schedule;
      }
    },
    saveSchedule() {
      this.schedule.teacherId = this.teacher.id;
      console.log("clicked save schedule", this.schedule);
      this.$axios
        .post("teacher/save-schedule", this.schedule)
        .then(() => {
          this.addSuccessMessage("Schedule saved successfully");
          this.$router.push({
            name: "Teacher",
            params: { id: this.teacher.id, tab: "tab-calendar" },
          });
        })
        .catch(() => {
          this.addErrorMessage("Error saving schedule");
        });
    },
  },
};
</script>

<style>
</style>